import React from "react";
import ComponentTitle from "../../../components/ComponentTitle/ComponentTitle";
import FaqItem from "../../../components/FaqItem";
import { useTranslation } from "react-i18next";
import Description from "../../../components/Description";

import {
  StyledContainer,
  StyledTitleContainer,
  StyledMainContainer,
  StyledGroupInner,
  StyledInnerContainer,
} from "./KvaliFaqStyle";

const KvaliFaq = ({ className, title }) => {
  const { t } = useTranslation();
  const firstColName = title ? "purchaseFistColumnData" : "fistColumnData"
  const secondColName = title ? "purchaseSecondColumnData" : "secondColumnData"

  const fistColumnData = t(firstColName, { returnObjects: true });
  const secondColumnData = t(secondColName, { returnObjects: true });

  return (
    <StyledContainer className={className || ''}>
      <StyledMainContainer>
        <StyledTitleContainer>
          <ComponentTitle Title value={title ? title : "Faq"} />
          <Description
            value={"kvaliFaqDescription"}
            textColor="#ADAEB6"
            textMaxWidth="75%"
            center
          />
        </StyledTitleContainer>
        <StyledInnerContainer>
          <StyledGroupInner>
            <FaqItem data={fistColumnData} />
          </StyledGroupInner>
          <StyledGroupInner>
            <FaqItem data={secondColumnData} />
          </StyledGroupInner>
        </StyledInnerContainer>
      </StyledMainContainer>
    </StyledContainer>
  );
};

export default KvaliFaq;
